import React from 'react';
import type { DocStatus } from '../../types/application';
const styles: Record<DocStatus, {
  label: string;
  cls: string;
  dot: string;
}> = {
  needed: {
    label: 'Needed',
    cls: 'bg-ink-100 text-ink-700',
    dot: 'bg-ink-400'
  },
  uploaded: {
    label: 'Uploaded',
    cls: 'bg-pulse-50 text-pulse-700',
    dot: 'bg-pulse-500'
  },
  reviewing: {
    label: 'Reviewing',
    cls: 'bg-caution-50 text-caution-700',
    dot: 'bg-caution-500'
  },
  accepted: {
    label: 'Accepted',
    cls: 'bg-positive-50 text-positive-700',
    dot: 'bg-positive-500'
  },
  attention: {
    label: 'Needs attention',
    cls: 'bg-critical-50 text-critical-700',
    dot: 'bg-critical-500'
  }
};
export function StatusBadge({
  status
}: {
  status: DocStatus;
}) {
  const s = styles[status];
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${s.cls}`} data-id="element-713" data-mp="1rx0xz4omi16m">
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot} ${status === 'reviewing' ? 'animate-pulse' : ''}`} aria-hidden data-id="element-714" data-mp="lfdqko9l6jcj" />
      {s.label}
    </span>;
}